import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  mainDiv: {
    position: 'sticky',
    top: '80px',
    backgroundColor: 'white',
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      top: '150px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar for Chrome, Safari and Opera
      '-ms-overflow-style': 'none', // Hide scrollbar for IE and Edge
      scrollbarWidth: 'none', // Hide scrollbar for Firefox
    },
    [theme.breakpoints.down(1250)]: {
      top: '147px',
    },
  },
  desktopNav: {
    display: 'flex',
    gap: '24px',
    justifyContent: 'flex-start',
    listStyle: 'none',
    padding: '10px 0',
    borderBottom: `3px solid ${colors.gray.l85}`,
    width: '100%',
    marginBottom: '0',
    [theme.breakpoints.down('md')]: {
      paddingBottom: '7px',
      minWidth: 'max-content',
    },
  },
  desktopNavItem: {
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    '& > a.active': {
      fontWeight: 600,
      borderBottom: `3px solid ${colors.blue.l45}`,
      paddingBottom: '9px',
      [theme.breakpoints.down('md')]: {
        paddingBottom: '4px',
      },
    },
  },
}));
